import * as turf from '@turf/turf'
/**
 * 添加视频，格式为webm格式视频
 * @param {String} id 图层id
 * @param {String} video 视频文件名称+后缀：只支持webm格式
 * @param {Array}  data 经纬度列表
 * @param {Number}  size 平铺大小（直径） 单位为米
 */
function addLayer(id, video, res, size = 10) {
  let mapbox = this.mapbox
  if (video.indexOf('.') < 0) {
    video += '.webm'
  }

  let options = { steps: 4, units: 'kilometers' }
  size = size / 1000
  let i = 0
  for (let item of res.features) {
    let center = item.geometry.coordinates
    // 围绕中心点创建区域闭合曲线
    let points = turf.circle(center, size, options)
    // 旋转135°为正南北
    const rotatedPoly = turf.transformRotate(points, 135, { pivot: center })
    rotatedPoly.geometry.coordinates[0].splice(0, 1)
    let layerId = id + i++

    if (mapbox.getLayer(layerId)) {
      mapbox.removeLayer(layerId)
    }
    // 若存在，删除
    if (mapbox.getSource(layerId)) {
      mapbox.removeSource(layerId)
    }
    mapbox.addSource(layerId, {
      type: 'video',
      urls: ['./map/video/' + video],
      coordinates: rotatedPoly.geometry.coordinates[0]
    })
    mapbox.addLayer({
      id: layerId,
      type: 'raster',
      source: layerId,
      layout: {
        visibility: 'visible'
      }
    })
  }
}
export default addLayer



// WEBPACK FOOTER //
// ./src/framework/map/layer/Video.js